// extracted by mini-css-extract-plugin
export default {"section":"Resume_section__lS7vc","resume":"Resume_resume__kO9qf","noCSSWarning":"Resume_noCSSWarning__Pnv79"};